@let j = job();
<div class="job__head" [attr.aria-hidden]="j.phase === 'running' ? 'true' : null">
  <span class="job__stage">{{ headline() }}</span>
  @if (j.percent !== null) {
    <span class="job__percent">{{ j.percent }}%</span>
  }
</div>
@if (j.phase === 'running') {
  <app-progress-bar class="job__bar" [value]="j.percent ?? 0" [ariaLabel]="headline()" [valueText]="valueText()" />
} @else {
  <app-progress-bar class="job__bar" [value]="j.percent ?? 0" aria-hidden="true" />
}
<div class="job__meta">
  @if (j.step !== null) {
    <span class="job__dots" aria-hidden="true">
      @for (i of steps; track i) {
        <span class="job__dot" [class.job__dot--done]="i < j.step" [class.job__dot--now]="i === j.step"></span>
      }
    </span>
  }
  @if (errors() > 0) {
    <span class="job__errors">{{ errorText() }}</span><span class="visually-hidden">, </span>
  }
  <span class="job__time">{{ timeText() }}</span>
</div>
